<template>
  <div id="app">
  	<el-table
    v-loading="this.$store.state.load.isLoading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    style="width:100%;height:100%;" v-if="this.$store.state.load.isLoading"></el-table>

  	<keep-alive>
    	<router-view v-if="$route.meta.keepAlive" />	<!-- 可以被换缓存的视图组件 -->
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />		<!-- 不可以被换缓存的视图组件 -->
  </div>
</template>

<script>
	export default {
	  name: 'App'
	}
</script>



// WEBPACK FOOTER //
// src/App.vue